var vms = vms || {};
vms.comment = vms.comment || {};

vms.comment.iconEl = null;

vms.comment.lxpComments = function (pSize, pMaxLength, pRecId, pEtyId) {
    var lSize = $nvl(pSize, 80);
    var lMaxLength = $nvl(pMaxLength, 2000);
    /*var $field = $("<textarea/>", {
        "placeholder": "Type your comment here.",
        "id": "htmlcmt_post",
        "size": lSize,
        "maxlength": lMaxLength
    });*/
    var lRecId = $nvl(pRecId, $v("P" + $v("pFlowStepId") + "_ID"));
    var lEtyId = $nvl(pEtyId, $v("P" + $v("pFlowStepId") + "_ENTITY_ID"));
	var lOwnId =  $v("P" + $v("pFlowStepId") + "_OWNER_ID");
	var lVslId = $v("P" + $v("pFlowStepId") + "_VESSEL_ID");
    var $cmt = $('#uiComments');
    getComments();
    //$cmt.append($field);
    $("#htmlcmt_post").keypress(function (e) {
        if (e.keyCode == 13 && !e.shiftKey) {
            e.preventDefault();
            $.ajax({
                url: "wwv_flow.show",
                dataType: "html",
                traditional: true,
                cache: false,
                type: "POST",
                data: {
                    p_flow_id: $v("pFlowId"),
                    p_flow_step_id: $v("pFlowStepId"),
                    p_instance: $v("pInstance"),
                    p_request: 'APPLICATION_PROCESS=SAVE_COMMENTS',
                    x01: lRecId,
                    x02: lEtyId,
                    x03: $v("htmlcmt_post")
                },
                success: function (d) {
                    if (d == 'NOK') {
                        raiseError("Error on insert!");
                    } else {
                        getComments();
                        if ($v("pFlowStepId") == 222) {
                            lxRefreshTList();
                        }
                        $(window.parent.vms.comment.iconEl).removeClass("fawe-plus").addClass("fawe-comment-alt-lines");
                    }
                }
            })
            $("#htmlcmt_post").val('');
            $('html, body').animate({
                scrollTop: $("#uiCommentSh").offset().top
            }, 'slow');
        }
    })

    function raiseError(p) {
        var lErr = $nvl(p, "You must be logged in to post a comment.");
        $("#htmlcmt_post").addClass('ui-state-error ui-corner-all fielddatabold');
        alert(lErr);
    }

    function getComments() {
        apex.server.process("getComments", {
            x01: lRecId,
            x02: lEtyId,
			x03: lOwnId,
			x04: lVslId
        }, {
                dataType: "html",
                success: function (pData) {
					console.log('js='+pData);
                    if (pData) $("#uiCommentSh").html(pData);
                }
            });
    }

}

vms.comment.lxCommentEdit = function (pType, pId) {
    var vTxt;
    if (pType == "U") vTxt = $v("E" + pId);
    if (pType == "E") {
        vTxt = $("#COMM" + pId).text();
        var field = '<textarea id="E' + pId + '" size="80" maxlength="1000" style="width:99%;">' + vTxt + '</textarea>';
        $("#COMM" + pId).html(field);
        $("#E" + pId).keypress(function (e) {
            if (e.keyCode == 13 && !e.shiftKey) {
                e.preventDefault();
                lxCommentEdit('U', pId)
            }
        });
    } else {
        apex.server.process("COMMENTS_EDIT", {
            x01: pType,
            x02: pId,
            x03: vTxt
        }, {
                dataType: "text",
                success: function (pData) {
                    if (pType == "D") {
                        if (pData) alert(pData);
                        else {
                            $("#COMMR" + pId).remove();
                            lxRefreshTList();
                        }
                    } else if (pType == "U") {
                        if (pData) alert(pData);
                        else $("#COMM" + pId).html(vTxt);
                    } else if (pType == "PR" || pType == "PU") getComments(pId, parseInt(pData));
                }
            });
    }

    function getComments(pRecId, pEtyId) {
        apex.server.process("getComments", {
            x01: pRecId,
            x02: pEtyId,
            x03: 'PRV'
        }, {
                dataType: "html",
                success: function (pData) {
                    if (pData) $("#uiCommentSh").html(pData);
                }
            });
    }
}

var lxpComments = vms.comment.lxpComments;
var lxCommentEdit = vms.comment.lxCommentEdit;